export default {
  namespaced: true,
  state: {
    keywordTargets: [],
  },
  persistentStates: ['keywordTargets'],
  mutations: {
    /**
     * stateを初期化する
     * @param {*} state
     */
    resetState(state) {
      state.keywordTargets = []
    },
    /**
     * 検索項目を設定する
     * @param {*} state
     * @param {Array.<String>} targets 検索項目
     */
    setKeywordTargets(state, targets) {
      state.keywordTargets = targets
    },
  },
  getters: {
    /**
     * 検索項目
     * @param {*} state
     * @returns {Array.<String>}
     */
    keywordTargets: (state) => state.keywordTargets,
  },
  actions: {
    /**
     * stateをリセットする
     */
    resetState({ commit }) {
      commit('resetState')
    },
    /**
     * 検索項目の設定
     * @param {Array.<String>} target 検索項目の設定値
     */
    setKeywordTargets({ commit }, target) {
      commit('setKeywordTargets', target)
    },
  },
}
